package com.ives.utils;

import sys.FileSystem;
import sys.io.File;

import haxe.ds.StringMap;
import haxe.macro.Context;
import haxe.macro.Expr;

class TranslationBuilderMacro {
	macro public static function build():Array<Field> {
		var fields:Array<Field> = Context.getBuildFields();

		var valuesMap:StringMap<StringMap<String>> = new StringMap<StringMap<String>>();

		var files:Array<String> = FileSystem.readDirectory("locale");

		for(file in files){
			var parts:Array<String> = file.split(".");

			var lang:String = parts[0];

			var langField:String = "lang_" + parts[0];

			fields.push({
				name: langField.toUpperCase(),
				access: [Access.APublic, Access.AStatic, Access.AInline],
				kind: FieldType.FVar(macro: String, macro $v{lang}),
				pos: Context.currentPos()
			});

			var lines:Array<String> = File.getContent("locale/" + file).split("\n");

			valuesMap.set(lang, new StringMap<String>());

			for(line in lines)
				if(line.indexOf("=") != -1){
					if(line.indexOf("#") != -1)
						line = line.split("#")[0];

					var parts:Array<String> = line.split("=");
					var key:String = StringTools.trim(parts[0]);
					var value:String = StringTools.trim(parts[1]);

					valuesMap.get(lang).set(key, value);
				}
		}

		var maps:Array<Expr> = [];

		for(lang in valuesMap.keys()){
			var map:Array<Expr> = [];

			for(key in valuesMap.get(lang).keys())
				map.push(macro $v{key} => $v{valuesMap.get(lang).get(key)});

			maps.push(macro $v{lang} => $a{map});
		}

		fields.push({
			name: "translations",
			kind: FieldType.FVar(macro : Map<String, Map<String, String>>, macro $a{maps}),
			access: [Access.APrivate, Access.AStatic],
			pos: Context.currentPos()
		});

		return fields;
	}
}
